import { FC } from 'react';
import classnames from 'classnames';

import styles from './styles.scss';

type Props = {
    sellerName: string;
    isSbTile?: boolean;
};

export const InternalSellerName: FC<Props> = ({ sellerName, isSbTile }) => {
    isSbTile = isSbTile || false;
    return (
        <div
            className={classnames(styles.internalByline, {
                [styles.isSbTile]: isSbTile,
            })}
            data-tn="internal-seller-name"
        >
            {sellerName}
        </div>
    );
};

export default InternalSellerName;
